export const Container = {
  baseStyle: {
    maxW: 'container.xl',
    px: 'padding.primary',
  },
}
